
import {
  ICallHistoryAdapter,
  IMakeCallAdapter,
  ISearchContactsAdapter,
  ISpeedDialsAdapter,
  IVoicemailAdapter,
  ICallSettingsAdapter
} from '@webex/component-adapter-interfaces/dist/esm/src';
import React, { createContext } from 'react';
import { IEventAdapter } from "../../../adapter-interfaces/src";

export interface IAdapterContext {
  user?: unknown;
  callHistoryAdapter?: ICallHistoryAdapter;
  searchContactsAdapter?: ISearchContactsAdapter;
  makeCallAdapter?: IMakeCallAdapter;
  speedDialsAdapter?: ISpeedDialsAdapter;
  voicemailAdapter?: IVoicemailAdapter;
  callForwardAdapter?:ICallSettingsAdapter;
  eventAdapter?: IEventAdapter
  // Optional Webex SDK instance (e.g., webex.internal.dss) for phone enrichment
  dss?: unknown;
}

export const AdapterContext = createContext<IAdapterContext>({});

export interface IAdapterProvider {
  adapter: IAdapterContext;
  children: React.ReactNode;
}

/**
 *
 * @param root0
 * @param root0.adapter
 * @param root0.children
 */
export const AdapterProvider = ({ adapter, children }: IAdapterProvider) => {
  return (
    <AdapterContext.Provider value={adapter}>
      {children}
    </AdapterContext.Provider>
  );
};
